import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=5130fef2&lang=pug"
import script from "./PopupMenu.vue?vue&type=script&lang=ts"
export * from "./PopupMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports